"use strict";

$.fn.forceDirty = function ($dirtyTracker) {
    var $form = this;
    if ($form.length > 1)
        $form = this[0];
    if ($form.prop("tagName") != "FORM") {
        $form = $form.parents("form");
        if ($form.prop("tagName") != "FORM")
            return this;
    }

    if ($dirtyTracker == undefined)
        $dirtyTracker = $form.find('#dirtyForm');

    $dirtyTracker.val(new Date());
    $form.trigger('checkform.areYouSure');

    return this;
}

$.fn.disableSubmitOnEnter = function () {
    this.on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    return this;
}

$.fn.isOnScreen = function () {

    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

$.fn.scrollIntoView = function (offset) {
    if (offset = undefined) offset = 0;
    $('html, body').animate({
        scrollTop: this.offset().top + offset
    }, 500);

    return this;
};

$.fn.insertDismissbleAlert = function (msg) {
    this.empty().append('<div class="alert alert-danger alert-dismissible" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
        + msg + '</div>');
}

function errorMessageViewDetails() {
    $('#errorMessages').on('hide.bs.collapse', function () {
        $('#errorMessagesViewMore').html('Show Details >>');
    }).on('show.bs.collapse', function () {
        $('#errorMessagesViewMore').html('Hide Details <<');
    });
}

$.fn.getHomeUrl = function () {
    return this.find('a.home-link').attr('href');
}

$.fn.setHomeUrl = function (newHomeUrl) {
    this.find('a.home-link').attr('href', newHomeUrl);

    window.history.pushState(null, null, newHomeUrl);

    return this;
}

module.exports.errorMessageViewDetails = errorMessageViewDetails;